// Cove Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const coveRoom: Room = {
  name: 'Cove',
  background: '/media/club-penguin/cove.jpg',
  spawn: { x: 501, y: 265 },
  // No music - peaceful cove

  colliders: [
    ...STANDARD_BOUNDARIES,

    { x: 24, y: 20, w: 220, h: 202 },
    { x: 251, y: 21, w: 691, h: 140 },
    { x: 26, y: 221, w: 89, h: 294 },
    { x: 119, y: 452, w: 189, h: 70 },
  ],

  hotspots: [
    {
      id: 'cove-to-plaza',
      x: 240,
      y: 134,
      w: 123,
      h: 73,
      action: 'goto',
      target: 'plaza',
      spawn: { x: 800, y: 400 },
    },
  ],
};
